import React, { useEffect, useState } from 'react';
import { CircularProgress, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { useGetDevelopmentsByIdQuery, useGetDevelopmentsQuery } from "../../../redux/vmsApi";
import createUnitModel from "../../forms/models/createUnitModel";

const {
  formField: {
    unitName,
    development,
    developmentName,
    projectName,
    project,
  },
} = createUnitModel;

const CreatUnitForm: React.FC = () => {
  const {errors, touched, values, setFieldValue} = useFormikContext<any>();
  const {data: developments = [], isLoading} = useGetDevelopmentsQuery();
  const [selectedDevelopment, setSelectedDevelopment] = useState('');
  const { data: developmentData } = useGetDevelopmentsByIdQuery(
    { id: selectedDevelopment },
    { skip: !selectedDevelopment }
  );

  const handleDevelopmentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const developmentId = event.target.value;
    setSelectedDevelopment(developmentId);
    setFieldValue('development', developmentId);
    setFieldValue('project', '');
  };

  useEffect(() => {
      if (developmentData) {
        setFieldValue('developmentName', developmentData.name);
      }
    }, [developmentData, setFieldValue]);

  const projects = selectedDevelopment
    ? developments.find((dev: any) => dev.id === selectedDevelopment)?.projects || []
    : [];

  const handleProjectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const projectId = event.target.value;
    const selectedProjectObject = projects.find(project => project.id === projectId);
    setFieldValue('project', projectId);
    if (selectedProjectObject) {
      setFieldValue('projectName', selectedProjectObject.name);
    }
  };

  if (isLoading) {
    return (
      <CircularProgress />
    )
  }

  return (
    <Stack width="100%" spacing={5}>
      <Typography variant='h4' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Add Unit
      </Typography>
      <Stack direction={'row'} spacing={2}>
        <Field
          as={TextField}
          fullWidth
          {...unitName}
          error={touched[unitName.name] && Boolean(errors[unitName.name])}
          helperText={touched[unitName.name] && errors[unitName.name] ? errors[unitName.name] : ''}
        />

        <Field
          as={TextField}
          fullWidth
          select

          {...development}
          value={values.development || ''}
          onChange={handleDevelopmentChange}
          sx={{ backgroundColor: '#fff', borderRadius: 1 }}
          error={touched[development.name] && Boolean(errors[development.name])}
          helperText={touched[development.name] && errors[development.name] ? errors[development.name] : ''}
        >
          {developments.map((development) => (
            <MenuItem key={development.id} value={development.id}>
              {development.name}
            </MenuItem>
          ))}
        </Field>

        <Field {...developmentName} type="hidden" />
        <Field {...projectName} type="hidden" />

        <Field
          as={TextField}
          fullWidth
          select

          {...project}
          value={values.project || ''}
          onChange={handleProjectChange}
          sx={{ backgroundColor: '#fff', borderRadius: 1 }}
          error={touched[project.name] && Boolean(errors[project.name])}
          helperText={touched[project.name] && errors[project.name] ? errors[project.name] : ''}
        >
          {projects.map((project) => (
            <MenuItem key={project.id} value={project.id}>
              {project.name}
            </MenuItem>
          ))}
        </Field>
      </Stack>
    </Stack>
  );
};

export default CreatUnitForm;
